export { useAdobeTargetPageView } from './useAdobeTargetPageView';
